export const BaseCard = (props) => {
    const {
        children,
        className = '',
        border = true
    } = props;

    return (
        <div className={`bg-white rounded-lg p-4 ${border ? 'border border-gray-200' : ''} ${className}`}>
            {children}
        </div>
    );
}